import styled from 'styled-components';
import { shouldIgnoreProp } from '../../../../utils/shouldIgnoreProp';
import { Box } from '../../../layout/Box';
import { BUTTON_HEIGHT_PRODUCT_EXPANDED, BUTTON_WIDTH_EXPANDED_INDENTION } from './constants';
import { ButtonBoxProps } from './types';

export const ButtonBox = styled(Box)
    .withConfig({
        displayName: 'ButtonBox',
        shouldForwardProp: shouldIgnoreProp('isExpanded', 'isProductExpanded'),
    })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        bottom: 0,
        right: 2,
        pointerEvents: 'auto',
        cursor: 'pointer',
        overflow: 'hidden',
        borderRadius: 2,
        width: 117,
        height: 32,
    }))<ButtonBoxProps>`
    will-change: border-radius;
    width: ${({ isExpanded, isProductExpanded = false }) =>
        (isExpanded || isProductExpanded) && `calc(100% - ${BUTTON_WIDTH_EXPANDED_INDENTION}px)`};
    height: ${({ isProductExpanded = false }) =>
        isProductExpanded && `${BUTTON_HEIGHT_PRODUCT_EXPANDED}px`};
`;
